// extracted by mini-css-extract-plugin
export var equalColumn = "_gt-0";